<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="review mt-40">
    <div class="d-flex justify-content-between">
      <div>
        <h4 v-if="review.reviewTitle" class="mb-16">
          {{ review.reviewTitle }}
        </h4>

        <div class="d-flex align-items-center">
          <StarsRating :rating="review.rating" />
          <small class="ml-8 text-small">
            {{ $label('books.reviews.authorAndDate', { author, createDate }) }}
          </small>
        </div>
      </div>

      <ReviewOptions
        v-if="loggedInUser"
        :review-uid="review.reviewUid"
        :report-review="reportReview"
        :review-from-user="reviewFromUser"
        :delete-review="deleteReview"
        :update-reviews="updateReviews"
      />
    </div>

    <div v-if="review.reviewDescription" class="mt-16">
      <ExpandableText
        v-if="review.reviewDescription.length > 697"
        max-height="200px"
        :text="review.reviewDescription"
        :tracking-label="bookTitle"
      />
      <p v-else class="text-pre-line mb-0">
        {{ review.reviewDescription }}
      </p>
    </div>

    <LikeReview
      :review="review"
      :logged-in-user="loggedInUser"
      :open-login-drawer="openLoginDrawer"
      :like-review="likeReview"
      :remove-like="removeLike"
    />
  </div>
</template>

<script>
import StarsRating from '~/components/reviews/StarsRating'
import ExpandableText from '~/components/ExpandableText'
import ReviewOptions from '~/components/reviews/ReviewOptions'
import LikeReview from '~/components/reviews/LikeReview'
import dateFormatter from '~/utils/dateFormatter'

export default {
  components: {
    StarsRating,
    ExpandableText,
    ReviewOptions,
    LikeReview,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    bookTitle: {
      type: String,
      required: true,
    },
    reportReview: {
      type: Function,
      required: true,
    },
    loggedInUser: {
      type: [Object, Boolean],
      default: false,
    },
    openLoginDrawer: {
      type: Function,
      required: true,
    },
    likeReview: {
      type: Function,
      required: true,
    },
    removeLike: {
      type: Function,
      required: true,
    },
    deleteReview: {
      type: Function,
      required: true,
    },
    updateReviews: {
      type: Function,
      required: true,
    },
  },
  computed: {
    author() {
      const { reviewAuthorFirstName, reviewAuthorLastName } = this.review
      const lastName = reviewAuthorLastName ? ` ${reviewAuthorLastName}` : ''

      return `${reviewAuthorFirstName}${lastName}`
    },
    createDate() {
      return dateFormatter(this.review.createDate)
    },
    reviewFromUser() {
      return this.loggedInUser && this.loggedInUser.id === this.review.userUid
    },
  },
}
</script>
